import Link from 'next/link';
import styled from 'styled-components';

export const Wrapper = styled.div<{ $gap: number }>`
  display: flex;
  gap: ${({ $gap }) => `${$gap}px`};
`;

export const IconLink = styled(Link)`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  color: var(--textAndLabels-main);
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;
